import { Component, OnInit, Input } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { General_Config } from '../General_Config';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-coupondetail',
  templateUrl: './coupondetail.page.html',
  styleUrls: ['./coupondetail.page.scss'],
})
export class CoupondetailPage implements OnInit {
  @Input() code: string;
  isLoading: boolean = false;
  isProcessing: boolean = false;
  dataForm: FormGroup;
  img_path: string = '';
  img_existing_path: string = '';
  constructor(public modalController: ModalController, public alertController: AlertController, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) { }

  ngOnInit() {
    this.dataForm = new FormGroup({
      'title': new FormControl(null, [Validators.required]),
      'code': new FormControl(null, [Validators.required]),
      'start_date': new FormControl(null, [Validators.required]),
      'end_date': new FormControl(null, [Validators.required]),
      'max_usage': new FormControl(null, [Validators.required]),
      'discount_type': new FormControl('percentage', [Validators.required]),
      'discount_amt': new FormControl(null, [Validators.required]),
      'usage_user': new FormControl(null, [Validators.required]),
      'min_cart_value': new FormControl(null, [Validators.required]),
      'max_discount_amt': new FormControl(null, [Validators.required]),
      'description': new FormControl(null, []),
      'file': new FormControl(null, []),
      'status': new FormControl(true, [Validators.required]),
      'show_banner': new FormControl(false, [Validators.required]),
      'path': new FormControl(null, [])
    });
    if (this.code != '') {
      this.getDetail();
    }
  }

  closeDialog() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  submitForm() {
    if (this.code == '') {
      this.add();
    } else {
      this.update();
    }
  }

  update() {
    this.isLoading = true;
    var formData = new FormData();
    for (let key in this.dataForm.value) {
      let value = this.dataForm.value[key];
      if (key == 'status' || key == 'show_banner') {
        if (value == true) {
          value = 1;
        } else {
          value = 0;
        }
      }
      formData.append(key, value);
    }
    formData.append('img_path', this.img_path);
    formData.append('img_existing_path', this.img_existing_path);
    this.restApi.put('coupon/' + this.code, formData).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        this.modalController.dismiss({
          'success': true
        });
      }
      this.commonFunctions.presentAlertConfirm('Information', data['message']);
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  add() {
    this.isLoading = true;
    var formData = new FormData();
    for (let key in this.dataForm.value) {
      let value = this.dataForm.value[key];
      if (key == 'status' || key == 'show_banner') {
        if (value == true) {
          value = 1;
        } else {
          value = 0;
        }
      }
      formData.append(key, value);
    }
    this.restApi.post('coupon', formData).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        this.modalController.dismiss({
          'success': true
        });
      }
      this.commonFunctions.presentAlertConfirm('Information', data['message']);
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  getDetail() {
    this.isProcessing = true;
    this.restApi.get('coupon/' + this.code).subscribe((data: any) => {
      this.isProcessing = false;
      if (data['code'] == 200) {
        this.dataForm.controls['title'].setValue(data['data']['title']);
        this.dataForm.controls['code'].setValue(this.code);
        this.dataForm.controls['start_date'].setValue(moment(data['data']['start_date']).format('YYYY-MM-DD'));
        this.dataForm.controls['end_date'].setValue(moment(data['data']['end_date']).format('YYYY-MM-DD'));
        this.dataForm.controls['max_usage'].setValue(data['data']['max_usage']);
        this.dataForm.controls['discount_type'].setValue(data['data']['discount_type']);
        this.dataForm.controls['discount_amt'].setValue(data['data']['discount_amt']);
        this.dataForm.controls['usage_user'].setValue(data['data']['usage_user']);
        this.dataForm.controls['min_cart_value'].setValue(data['data']['min_cart_value']);
        this.dataForm.controls['max_discount_amt'].setValue(data['data']['max_discount_amt']);
        this.dataForm.controls['description'].setValue(data['data']['description']);
        this.dataForm.controls['status'].setValue(data['data']['status']);
        this.dataForm.controls['show_banner'].setValue(data['data']['show_banner']);
        if (data['data']['path'] != '') {
          this.img_path = General_Config.image_base + data['data']['path'];
          this.img_existing_path = data['data']['path'];
        }
      }
    }, (error: any) => {
      this.isProcessing = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  fileProgress(event, param) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      this.dataForm.patchValue({
        path: event.target.files[0],
      });
      reader.onload = (e: any) => {
        this[param] = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  removeImage() {
    this.dataForm.patchValue({
      path: null,
      file: null
    });
    this.img_path = '';
  }
}
